import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/index')
  },
  {
    path: '/zh',
    redirect: '/'
  },
  {
    path: '/zh/*',
    redirect: '/'
  },
  {
    path: '/en',
    redirect: '/'
  },
  {
    path: '/en/*',
    redirect: '/'
  },
  {
    path: '/v4',
    name: 'v4',
    component: () => import('../pages/v4')
  },
  {
    path: '/auth-signup',
    name: 'signup',
    component: () => import('../pages/auth-signup')
  },
  {
    path: '/auth-login',
    name: 'login',
    component: () => import('../pages/auth-login')
  },
  {
    path: '/api/logout',
    name: 'logout'
  },
  {
    path: '/auth-re-password',
    name: 'reset-password',
    component: () => import('../pages/auth-re-password')
  },
  {
    path: '/photoshop',
    name: 'install-photoshop',
    component: () => import('../pages/photoshop')
  },
  {
    path: '/sketch',
    name: 'install-sketch',
    component: () => import('../pages/sketch')
  },
  {
    path: '/xd',
    name: 'install-xd',
    component: () => import('../pages/xd')
  },
  {
    path: '/figma',
    name: 'install-figma',
    component: () => import('../pages/figma')
  },
  {
    path: '/jsdesign',
    name: 'install-jsdesign',
    component: () => import('../pages/jsdesign')
  },
  {
    path: '/mastergo',
    name: 'install-mastergo',
    component: () => import('../pages/mastergo')
  },
  {
    path: '/mobile',
    name: 'install-app',
    component: () => import('../pages/mobile-app')
  },
  {
    path: '/blog-list',
    name: 'blog-list',
    component: () => import('../pages/page-blog-list')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../pages/page-faqs')
  },
  {
    path: '/buy',
    name: 'buy',
    component: () => import('../pages/buy')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../pages/buy-team')
  },
  {
    path: '/member-update',
    name: 'member-update',
    component: () => import('../pages/member-update')
  },
  {
    path: '/shop-cart',
    name: 'shop-cart',
    component: () => import('../pages/shop-cart')
  },
  {
    path: '/shop-result',
    name: 'shop-result',
    component: () => import('../pages/shop-result')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../pages/profile')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../pages/terms')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../pages/page-privacy')
  },
  {
    path: '*',
    component: () => import('../pages/page-error')
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
